import React from 'react';
import RegisterUser from './../pages/auth/register/RegisterPage'

function Signup() {

	return (
		<RegisterUser />
	);
}

export default Signup;
